var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtAndDesign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Content-Brush-Pen--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Content Brush Pen Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.13 11.05 -3 -3a0.51 0.51 0 0 0 -0.7 0L4 16.48a1.5 1.5 0 0 0 -0.44 1.06A1.48 1.48 0 0 0 4 18.6l1.59 1.59a1.49 1.49 0 0 0 1.06 0.44 1.51 1.51 0 0 0 1.06 -0.44l8.43 -8.44a0.48 0.48 0 0 0 -0.01 -0.7Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.34 20.29 -2 2a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2 -2a1 1 0 0 0 -1.42 -1.42Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.19 10a0.54 0.54 0 0 0 0.36 0.14 0.52 0.52 0 0 0 0.35 -0.14l3.42 -3.43 0.38 0.43a1.09 1.09 0 0 1 0.3 0.79 1.1 1.1 0 0 1 -0.3 0.79l-3.85 3.85a1 1 0 1 0 1.41 1.42L23.12 10a3.22 3.22 0 0 0 0 -4.42L19.38 1.8a0.48 0.48 0 0 0 -0.7 0l-4.36 4.35c-0.19 0.2 -0.32 0.64 -0.13 0.84Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72 11.74a3.75 3.75 0 0 0 3.63 -1.63 4.07 4.07 0 0 0 0.53 -3.76A4.32 4.32 0 0 0 5.76 3.7C4.25 3.21 2.94 2.8 3.05 0.52A0.52 0.52 0 0 0 2.76 0a0.52 0.52 0 0 0 -0.56 0.1A6.85 6.85 0 0 0 0.33 7.27c0.67 2.31 2.52 4.15 4.39 4.47Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.65 14.6a0.5 0.5 0 0 0 -0.66 0l-1.94 1.94a0.47 0.47 0 0 0 -0.14 0.36 0.48 0.48 0 0 0 0.16 0.36l7.14 6.57a0.53 0.53 0 0 0 0.34 0.13h0.59a2.36 2.36 0 0 0 1.78 -0.49 3.45 3.45 0 0 0 0.63 -2.47 0.51 0.51 0 0 0 -0.19 -0.4Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtAndDesign);
export default ForwardRef;